<template>
  <div class="text-center">
    <v-card align="start" flat>
      <v-row class="ma-0 pa-0" align="center">
        <template v-for="(header, id) in dataheaders">
          <v-tooltip v-if="showAllFilters || !header.hidden" bottom :key="id" :disabled="findFilter(header) == undefined">
            <template v-slot:activator="{ on }">
              <v-chip
                v-on="on"
                class="ma-1"
                :color="findFilter(header) != undefined ? Colors.IconColor : ''"
                :close="findFilter(header) != undefined"
                :filter="header.proptype == DataPropType.BOOL && findFilter(header) != undefined"
                :filter-icon="findFilter(header) == undefined ? undefined : findFilter(header).vals[0] == true ? 'mdi-check' : 'mdi-close'"
                outlined
                @click="showFilterSheetData(header)"
                @click:close="clearFilter(header)"
              >
                {{ getFilterText(header) }}
              </v-chip>
            </template>
            {{ findFilter(header) != undefined ? findFilter(header).toString() : "" }}
          </v-tooltip>
        </template>
        <v-divider class="ma-1" vertical></v-divider>
        <v-chip text @click="showAllFilters = !showAllFilters">
          <span>{{ showAllFilters ? s_Less : s_More }}</span>
        </v-chip>
        <v-btn text small color="error" @click="clearFilters">
          <span class="subtitle-1">{{ s_Clear }}</span>
        </v-btn>
        <!-- <v-chip text small @click="showAllFilters = !showAllFilters">
          <v-icon small>{{ showAllFilters ? "mdi-arrow-expand-left" : "mdi-arrow-expand-right" }}</v-icon>
        </v-chip>
        <v-btn text small color="error" @click="clearFilters">
          <span class="subtitle-1">{{ s_Clear }}</span>
        </v-btn> -->
      </v-row>
    </v-card>

    <v-bottom-sheet v-model="showFilterSheet" v-if="showFilterSheet" inset :width="getSheetWidth()">
      <v-sheet class="text-center" :height="700" :width="getSheetWidth()">
        <v-card class="box-container" flat :height="700" :width="getSheetWidth()">
          <v-row class="row-header ma-0 pa-3" justify="start" align="center">
            <v-btn text icon outlined @click="closeFilters">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <span class="ml-3 subtitle">{{ s_FilterBy + " " + currentFilter.text }}</span>
            <v-spacer></v-spacer>
            <v-btn v-if="currentFilterData" color="success" dark rounded @click="applyFilter">
              <v-icon left>mdi-check</v-icon>
              <span class="subtitle-2">{{ s_Append }}</span>
            </v-btn>
          </v-row>
          <v-divider class="row-header"></v-divider>
          <v-row class="row-content-limited ma-0 px-3 pt-5" align="start" justify="center">
            <FilterChips
              v-if="currentFilter.proptype == DataPropType.String || currentFilter.proptype == DataPropType.WeekDays || currentFilter.proptype == DataPropType.Month || currentFilter.proptype == DataPropType.SaleType"
              :data="currentFilterData"
              v-model="currentFilter.vals"
            />
            <FilterSlider v-if="currentFilter.proptype == DataPropType.Number" :step="1" :data="currentFilterData" v-model="currentFilter.vals" />
            <FilterSlider v-if="currentFilter.proptype == DataPropType.Money" :step="0.01" :data="currentFilterData" v-model="currentFilter.vals" />
            <FilterSlider v-if="currentFilter.proptype == DataPropType.QTY" :step="0.001" :data="currentFilterData" v-model="currentFilter.vals" />
            <!-- <FilterDateTimePicker v-if="currentFilter.proptype === DataPropType.Date" :data="currentFilterData" v-model="currentFilter.vals" /> -->
            <FilterDatePicker v-if="currentFilter.proptype === DataPropType.Date" :data="currentFilterData" v-model="currentFilter.vals" />
            <FilterDatePicker v-if="currentFilter.proptype === DataPropType.DateShort" :data="currentFilterData" v-model="currentFilter.vals" />
          </v-row>
        </v-card>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
import FilterChips from "./FilterChips";
import FilterSlider from "./FilterSlider";
import FilterDatePicker from "./FilterDatePicker.vue";
//import FilterDateTimePicker from "./FilterDateTimePicker.vue";

import DataManager, { DataFilter, DataFilterType, DataPropType } from "../../../js/DataManager.js";
import { TR } from "../../../main";

export default {
  name: "myNewFilter",
  props: {
    datatype: null,
  },
  components: {
    FilterChips,
    FilterSlider,
    FilterDatePicker,
    //FilterDateTimePicker,
  },
  data() {
    return {
      showFilterSheet: false,
      showAllFilters: false,
      boolFilters: [],
      filters: [],
      currentFilter: null,
      currentFilterData: null,
      modalCalendar_range: false,
      modalCalendar_single: false,

      date: new Date().toStringWithFormat("yyyy-MM-dd"),
      dates: [new Date().toStringWithFormat("yyyy-MM-dd"), new Date().toStringWithFormat("yyyy-MM-dd")],
      filterTypes: [],
      /** @type {DataFilter[]} */
      datafilters: [],
      /** @type {DataHeader[]} */
      dataheaders: [],
      dataitems: [],

      filtersText: [],
      s_Clear: TR.Clear,
      s_More: TR.More,
      s_Less: TR.Less,
      s_Append: TR.Append,
      s_FilterBy: TR.FilterBy,
    };
  },
  computed: {
    DataPropType() {
      return DataPropType;
    },
    DataFilterType() {
      return DataFilterType;
    },
  },
  methods: {
    getSheetWidth() {
      if (this.currentFilter.proptype == DataPropType.Date || this.currentFilter.proptype == DataPropType.DateShort) return this.isOnMobile ? undefined : 500;
      else return undefined;
    },
    setBoolFilter(header) {
      let index = this.boolFilters.indexOf(header);
      if (index > -1) this.boolFilters.splice(index, 1);
      else this.boolFilters.push(header);
      this.showFilterSheetData(header);
    },
    findFilter(header) {
      return this.datafilters.find((f) => f.propname == header.value);
    },
    getFilterText(header) {
      var filter = this.findFilter(header);
      if (!filter) return header.text;
      var vals = filter.vals;
      if (vals.length == 0 || vals[0] == null) return header.text;
      switch (header.proptype) {
        case DataPropType.Number:
          return header.text + " (" + vals[0] + " - " + vals[1] + ")";
        case DataPropType.Money:
          return header.text + " (" + vals[0].toFixed(2) + " - " + vals[1].toFixed(2) + ")";
        case DataPropType.QTY:
          return header.text + " (" + vals[0].toFixed(3) + " - " + vals[1].toFixed(3) + ")";
        case DataPropType.Date:
        case DataPropType.DateShort:
          return header.text + (" (" + vals[0].toTremolFpStringShort() + " - " + vals[1].toTremolFpStringShort() + ")");
        case DataPropType.String:
        case DataPropType.SaleType:
        case DataPropType.Month:
        case DataPropType.WeekDays:
          return header.text + ` (${vals.length})`;
        case DataPropType.BOOL:
          return header.text + (vals[0] == true ? " (" + TR.Yes + ")" : " (" + TR.No + ")");
      }
    },
    clearFilter(header) {
      var f = this.findFilter(header);
      if (f) {
        f.vals[0] = null;
        this.currentFilter = f;
        this.applyFilter();
      }
    },
    clearFilters() {
      DataManager.setFilters(this.datatype, []);
      this.currentFilter = null;
    },
    applyFilter() {
      DataManager.appendFilter(this.datatype, this.currentFilter);
      this.closeFilters();
    },
    closeFilters() {
      // this.showAllFilters = false;
      this.showFilterSheet = false;
      this.currentFilter = null;
    },
    showFilterSheetData(header) {
      let filterType = null;

      var filter = this.findFilter(header);
      var vals = [];
      switch (header.proptype) {
        case DataPropType.Date:
        case DataPropType.DateShort:
          filterType = DataFilterType.Between;

          this.currentFilterData = [new Date(), new Date()];
          if (!filter) {
            vals.push(new Date());
            vals.push(new Date());
          }
          break;

        case DataPropType.Number:
        case DataPropType.Money:
        case DataPropType.QTY:
          filterType = DataFilterType.Between;
          var numbers = this.dataitems.filter((o) => Object.byString(o, header.value)).map((p) => Object.byString(p, header.value));
          if (numbers.length == 0) this.currentFilterData = null;
          else this.currentFilterData = [Math.min(...numbers), Math.max(...numbers)];
          if (!filter) {
            vals.push(null);
            vals.push(null);
          }
          break;

        case DataPropType.WeekDays:
          filterType = DataFilterType.WeekDays;
          this.currentFilterData = DataManager.WeekDays.slice(0, DataManager.WeekDays.length);
          break;

        case DataPropType.String:
        case DataPropType.SaleType:
        case DataPropType.Month:
          filterType = DataFilterType.In;
          this.currentFilterData = this.getFilterDistinctValuesByName(this.datatype, header.value);
          break;

        case DataPropType.BOOL:
          filterType = DataFilterType.Equals;
          if (!filter) {
            vals.push(true);
          } else if (filter.vals[0] == true) {
            filter.vals[0] = false;
          } else {
            filter.vals[0] = null;
          }
          break;
      }

      if (filter) {
        this.currentFilter = new DataFilter(filter.propname, filter.text, filter.type, filter.proptype, filter.vals); // Object.assign({}, filter);
      } else {
        this.currentFilter = new DataFilter(header.value, header.text, filterType, header.proptype, vals);
      }
      if (header.proptype == DataPropType.BOOL) this.applyFilter();
      else this.showFilterSheet = !this.showFilterSheet;
    },

    getFilterDistinctValuesByName(datatype, propname) {
      return DataManager.getFilterDistinctValuesByName(datatype, propname);
    },
    getFilterDistinctValues(datatype, datafilter) {
      return DataManager.getFilterDistinctValues(datatype, datafilter);
    },
  },

  created() {
    this.dataheaders = DataManager.getHeaders(this.datatype).filter((h) => h.value != "date" && h.value != "my_custom_number");
    this.datafilters = DataManager.getFilters(this.datatype.id);
    this.dataitems = DataManager.getData(this.datatype).map((i) => i);
  },
};
</script>
